"use client";

import { ReactNode } from "react";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

interface FilterDropdownProps<T = string> {
  label?: string;
  options: T[];
  value: T | null;
  onChange: (value: T | null) => void;
  getLabel?: (value: T | null) => ReactNode;
  allLabel?: ReactNode;
  className?: string;
}

export function FilterDropdown<T = string>({
  label,
  options,
  value,
  onChange,
  getLabel = (v) => (v ? String(v) : "All"),
  allLabel = "All",
  className,
}: FilterDropdownProps<T>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className={className}>
          {label ? label + ": " : ""}
          {getLabel(value) || allLabel}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem onSelect={() => onChange(null)}>
          {allLabel}
        </DropdownMenuItem>
        {options.map((option) => (
          <DropdownMenuItem
            key={String(option)}
            onSelect={() => onChange(option)}
          >
            {getLabel(option)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
